module.exports = __webpack_public_path__ + "static/tw-25-cryptos-hover-da95c04cd2888b36d34793822118a161.jpg";